import { format } from 'date-fns-tz';

import { getLinkTextCellColumn } from 'src/app/components/lib/table';

import type { GridColDef } from '@mui/x-data-grid-pro';

export function useSmsColumns() {
  const baseColumns: GridColDef[] = [
    getLinkTextCellColumn({
      field: 'name',
      headerName: 'Name',
      valueGetter: (params) => {
        const { row } = params;
        return `${String(row.FirstName)} ${String(row.LastName)}`;
      },
    }),
    { field: 'PhoneNumber', headerName: 'Phone Number' },
    {
      field: 'SentUtc',
      headerName: 'Sent',
      valueGetter: ({ row }) => (row.SentUtc ? format(new Date(`${String(row.SentUtc)}`), 'MM/dd/yyyy hh:mm a') : '--'),
      sortable: false,
    },
    {
      field: 'DeliveredUtc',
      headerName: 'Delivered',
      valueGetter: ({ row }) =>
        row.DeliveredUtc ? format(new Date(`${String(row.DeliveredUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'ClickedUtc',
      headerName: 'Clicked',
      valueGetter: ({ row }) =>
        row.ClickedUtc ? format(new Date(`${String(row.ClickedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'PassedVerificationUtc',
      headerName: 'Passed Verification',
      valueGetter: ({ row }) =>
        row.PassedVerificationUtc
          ? format(new Date(`${String(row.PassedVerificationUtc)}`), 'MM/dd/yyyy hh:mm a')
          : '--',
      sortable: false,
    },
    {
      field: 'FailedUtc',
      headerName: 'Failed',
      valueGetter: ({ row }) =>
        row.FailedUtc ? format(new Date(`${String(row.FailedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'BouncedUtc',
      headerName: 'Bounced',
      valueGetter: ({ row }) =>
        row.BouncedUtc ? format(new Date(`${String(row.BouncedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'UnsubscribedUtc',
      headerName: 'Unsubscribed',
      valueGetter: ({ row }) =>
        row.UnsubscribedUtc ? format(new Date(`${String(row.UnsubscribedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
  ];

  return baseColumns;
}
